import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the MeasurementDetailSimple state domain
 */

const selectMeasurementDetailSimpleDomain = (state) =>
  state.get("Processes", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoading = () =>
  createSelector(selectMeasurementDetailSimpleDomain, (state) =>
    state.get("isLoading")
  )

export const makeSelectMeasureSimple = () =>
  createSelector(selectMeasurementDetailSimpleDomain, (state) =>
    state.get("measureSimple")
  )
  export const makeSelectIsLoadingMeasure = () =>
  createSelector(selectMeasurementDetailSimpleDomain, (state) =>
    state.get("isLoadingMeasure")
  )

export const makeSelectActiveMeasure = () =>
  createSelector(selectMeasurementDetailSimpleDomain, (state) =>
    state.get("activeMeasure")
  )
  export const makeSelectIsLoadingReprocess = () =>
  createSelector(selectMeasurementDetailSimpleDomain, (state) =>
    state.get("isLoadingReprocess")
  )

export const makeSelectActiveReprocess = () =>
  createSelector(selectMeasurementDetailSimpleDomain, (state) =>
    state.get("activeReprocess")
  )
/**
 * Default selector used by MeasurementDetailSimple
 */

const makeSelectMeasurementDetailSimple = () =>
  createSelector(selectMeasurementDetailSimpleDomain, (substate) => substate.toJS())

export default makeSelectMeasurementDetailSimple
export { selectMeasurementDetailSimpleDomain }
